'use client'

import useMetaPixelTimeSpent from './use-meta-pixel-time-spent'

const MetaPixelTimeSpentScript = () => {
  useMetaPixelTimeSpent()
  return null
}

export default MetaPixelTimeSpentScript
